import { graphql, useStaticQuery } from "gatsby"

const useLinksCollection = () => {
  const data = useStaticQuery(graphql`
    query AllCollectionLinksQuery {
      links: allCollectionLinks {
        nodes {
          externalLink
          title
          topics {
            id
            title
          }
          public {
            slug
          }
        }
      }
    }
  `)

  return {
    byTopic: data.links.nodes.filter(link => link.topics !== null),
    general: data.links.nodes.filter(link => link.topics === null),
  }
}

export default useLinksCollection
